'use client'

import {useEffect, useState} from 'react'
import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import {mercuryAppUrlWithPath} from '~/data/mercury'
import {
  HgButtonLink,
  HgComposableDetailsContent,
  HgComposableDetailsTitle,
} from '~/design-system/hg/components'
import {mercuryAppPaths} from '~/routing/external-links'
import {hasLoggedInCookie} from '~/utils/hasLoggedInCookie'
import {hasCanSeePerksCookie} from '../../_utils/hasCanSeePerksCookie'
import {type PerkDetailPageProps} from '../types'

type PerkDetailCookieContentProps = Pick<
  PerkDetailPageProps,
  'dealInstructions' | 'dealRules' | 'slug'
>

const LogInCTA = ({slug}: {slug: string}) => (
  <HgButtonLink
    href={`${mercuryAppUrlWithPath(mercuryAppPaths.perkRedirect)}?perkSlug=${slug}`}
    variant="tonal"
  >
    Log In
  </HgButtonLink>
)

export default function PerkDetailCookieContent({
  dealInstructions,
  dealRules,
  slug,
}: PerkDetailCookieContentProps) {
  const [canSeePerk, setCanSeePerk] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showContent, setShowContent] = useState(false)

  useEffect(() => {
    setCanSeePerk(hasCanSeePerksCookie())
    setIsLoggedIn(hasLoggedInCookie())
    setShowContent(true)
  }, [])

  if (!showContent) return null

  return isLoggedIn ? (
    <>
      {dealRules && (
        <HgComposableDetailsContent variant="oneColumn">
          <HgComposableDetailsTitle
            title="Rules"
            classNames={{body: 'space-y-16 arcadia-body-2 [&_span]:block'}}
            body={<SingleLineStructuredText data={dealRules} />}
          />
        </HgComposableDetailsContent>
      )}
      <HgComposableDetailsContent variant="oneColumn">
        <HgComposableDetailsTitle
          title="Instructions"
          classNames={{body: 'arcadia-body-2'}}
          body={
            canSeePerk ? (
              <SingleLineStructuredText data={dealInstructions} />
            ) : (
              <div className="flex flex-col space-y-s2">
                <p>
                  To see the details of this perk, make sure you’re logged in and an
                  Admin or Bookkeeper with an active org.
                </p>
                <LogInCTA slug={slug} />
              </div>
            )
          }
        />
      </HgComposableDetailsContent>
    </>
  ) : (
    <HgComposableDetailsContent variant="oneColumn">
      <HgComposableDetailsTitle title="Redeem" body={<LogInCTA slug={slug} />} />
    </HgComposableDetailsContent>
  )
}
